import { useState } from 'react'
import { Loader2, PlugZap, CheckCircle2, AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTestConnectionFidelizacion } from '../hooks/useFidelizacion'
import type { TestConnectionResult } from '../types'

interface TestConnectionButtonProps {
  configId: number
  size?: 'sm' | 'default'
  onResult?: (result: TestConnectionResult) => void
}

export function TestConnectionButton({ configId, size = 'sm', onResult }: TestConnectionButtonProps) {
  const test = useTestConnectionFidelizacion()
  const [lastResult, setLastResult] = useState<TestConnectionResult | null>(null)

  const handleClick = async () => {
    try {
      const result = await test.mutateAsync(configId)
      setLastResult(result)
      onResult?.(result)
    } catch {
      // El error queda en mutationState; el banner global lo cubre.
    }
  }

  const Icon = test.isPending
    ? Loader2
    : lastResult?.success === true
      ? CheckCircle2
      : lastResult?.success === false
        ? AlertCircle
        : PlugZap

  const variant = lastResult?.success === false ? 'destructive' : 'outline'

  return (
    <Button
      onClick={handleClick}
      disabled={test.isPending}
      size={size}
      variant={variant}
      className="inline-flex items-center gap-2"
      title={lastResult?.message}
    >
      <Icon className={`h-4 w-4 ${test.isPending ? 'animate-spin' : ''}`} />
      {test.isPending ? 'Probando...' : 'Probar conexión'}
    </Button>
  )
}
